module.exports = __webpack_public_path__ + "static/img/confetti.e49e2ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/other/thumbnail/confetti.png
// module id = fjF9
// module chunks = 0